(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["net.sergeych.hexword2-v1.2.14"] = factory();
	else
		root["net.sergeych.hexword2-v1.2.14"] = factory();
})(this, () => {
return 